import React, { useRef } from "react";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { Flex } from "@chakra-ui/react";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { registerGsapPlugins } from "lib/gsap";
import { StepTwoSvg } from "./step-2-svg";

registerGsapPlugins(ScrollTrigger);

export function StepTwoAnimation() {
  const ref = useRef<HTMLDivElement>(null);
  const timeline = useRef<GSAPTimeline>();

  useGSAP(
    () => {
      timeline.current = gsap
        .timeline({
          delay: 0.75,
          repeat: -1,
          yoyo: true,
          repeatDelay: 1.75,
          defaults: {
            duration: 0.6,
            ease: "power2.inOut",
          },
          scrollTrigger: {
            trigger: "#step-2-svg",
            onEnter: () => timeline.current?.restart(true), // Start the animation when the trigger enters
            onLeave: () => timeline.current?.pause(), // Pause the animation when the trigger leaves
            onEnterBack: () => timeline.current?.restart(true), // Start the animation when the trigger enters back from leaving
            onLeaveBack: () => timeline.current?.pause(), // Pause the animation when the trigger leaves back from entering
          },
        })
        .to("#toggle-switch", {
          x: 36,
          fill: "var(--chakra-colors-new-green-300)",
          duration: 0.3,
          ease: "elastic.out(0.4, 0.7)",
        })
        .to(
          "#start-line-1",
          {
            scaleX: 0,
            transformOrigin: "right",
          },
          "-=0.15",
        )
        .to(
          "#text-line-1",
          {
            opacity: 1,
          },
          "<",
        )
        .from(
          "#reveal-line-1",
          {
            opacity: 0,
            scaleX: 0,
          },
          "<",
        )
        .to(
          "#start-line-2",
          {
            scaleX: 0,
            transformOrigin: "right",
          },
          "-=0.3",
        )
        .to(
          "#text-line-2",
          {
            opacity: 1,
          },
          "<",
        )
        .from(
          "#reveal-line-2",
          {
            opacity: 0,
            scaleX: 0,
          },
          "<",
        )
        .to(
          "#start-line-3",
          {
            scaleX: 0,
            transformOrigin: "right",
          },
          "-=0.3",
        )
        .to(
          "#text-line-3",
          {
            opacity: 1,
          },
          "<",
        )
        .from(
          "#reveal-line-3",
          {
            opacity: 0,
            scaleX: 0,
          },
          "<",
        );
    },
    { scope: ref },
  );

  return (
    <Flex ref={ref} align="center" justify="center" boxSize="100%" pr="big" pos="relative">
      <StepTwoSvg id="step-2-svg" boxSize="100%" />
    </Flex>
  );
}
